import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { FieldArrayType, FormlyModule } from '@ngx-formly/core'

@Component({
	selector: 'gwc-multiple',
	templateUrl: './multiple.component.html',
	styleUrls: ['./multiple.component.scss'],
	imports: [
	  FormlyModule,
	  MatButtonModule,
		CommonModule
	]
})

export class MultipleComponent extends FieldArrayType {}
